export const isAttendanceFeatureEnabled = () =>
  process.env.REACT_APP_FEATURE_ATTENDANCE === 'true';
